import { render } from "./LoadMoreButton.vue?vue&type=template&id=0c395cd8"
import script from "./LoadMoreButton.vue?vue&type=script&lang=js"
export * from "./LoadMoreButton.vue?vue&type=script&lang=js"

import exportComponent from "E:\\_____LARAGON\\laragon\\www\\finalMatilda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__